import { sortBy } from 'lodash';
import { capList } from './EngagementInsightCard.helper';
var COMPLETION_THRESHOLD = 0.8;
var LOW_COMPLETION_LIST_CAP = 5;
export var getBelowCompletionThreshold = function (assignments) {
    return assignments.filter(function (assignment) { return assignment.percentComplete < COMPLETION_THRESHOLD; });
};
export var getDisplayedBelowCompletionAssignments = function (assignments) {
    return capList(sortBy(getBelowCompletionThreshold(assignments), ['percentComplete']), LOW_COMPLETION_LIST_CAP);
};
